import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { routeTemplateFromSnapshot } from './route-template';
import { TelemetryService } from './telemetry.service';

/** Starts RUM and records a page view per navigation using the route template. */
@Injectable({ providedIn: 'root' })
export class RouteTelemetryService {
  private readonly router = inject(Router);
  private readonly telemetry = inject(TelemetryService);

  init(): void {
    if (!this.telemetry.isEnabled()) {
      return;
    }
    const started = this.telemetry.start();
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
      const template = routeTemplateFromSnapshot(this.router.routerState.snapshot.root);
      void started.then(() => this.telemetry.recordPageView(template));
    });
  }
}
